import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDialogFlag } from '../modules/dialogs/actions';

/**
 * Ersetzt das frühere DialogContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `dialog.xxx`/`dialog.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - siehe useTreeState.js fuer die Begruendung
 * (sonst droht eine Endlosschleife, wenn ein Setter in einer Effekt-Dependency landet).
 */
export function useDialogState() {
    const dialogs = useSelector((state) => state.dialogs);
    const dispatch = useDispatch();

    const setOpen = useCallback((value) => dispatch(setDialogFlag('open', value)), [dispatch]);
    const setSubOpen = useCallback((value) => dispatch(setDialogFlag('subOpen', value)), [dispatch]);
    const setSubConfirmOpen = useCallback((value) => dispatch(setDialogFlag('subConfirmOpen', value)), [dispatch]);
    const setUpdateCompOpen = useCallback((value) => dispatch(setDialogFlag('updateCompOpen', value)), [dispatch]);
    const setDeleteCompOpen = useCallback((value) => dispatch(setDialogFlag('deleteCompOpen', value)), [dispatch]);
    const setUpdateAttrOpen = useCallback((value) => dispatch(setDialogFlag('updateAttrOpen', value)), [dispatch]);
    const setDeleteAttrOpen = useCallback((value) => dispatch(setDialogFlag('deleteAttrOpen', value)), [dispatch]);
    const setAttrOpen = useCallback((value) => dispatch(setDialogFlag('attrOpen', value)), [dispatch]);
    const setBimOpen = useCallback((value) => dispatch(setDialogFlag('bimOpen', value)), [dispatch]);

    return {
        open: dialogs.open, setOpen,
        subOpen: dialogs.subOpen, setSubOpen,
        subConfirmOpen: dialogs.subConfirmOpen, setSubConfirmOpen,
        updateCompOpen: dialogs.updateCompOpen, setUpdateCompOpen,
        deleteCompOpen: dialogs.deleteCompOpen, setDeleteCompOpen,
        updateAttrOpen: dialogs.updateAttrOpen, setUpdateAttrOpen,
        deleteAttrOpen: dialogs.deleteAttrOpen, setDeleteAttrOpen,
        attrOpen: dialogs.attrOpen, setAttrOpen,
        bimOpen: dialogs.bimOpen, setBimOpen,
    };
}
